/////////////////////////////////////
// All Code used for traking user progress and interacting with server
/////////////////////////////////////
jQuery(function ($) {

	//define players constant that will be used thru whole interaction
	const players = Plyr.setup('.js-video');
	const getStorageItem = itemName => { return JSON.parse(localStorage.getItem(itemName)) } //helper function to get data from localstorage


	const userData = getStorageItem("userProgress");
	var allVideoIdsInChapter;
	if(userData && userData.videos) {
		allVideoIdsInChapter = [...userData.videos.map(video => {  return video.id}) ] //filter to get only video ids from the localstorage
	} else {
		allVideoIdsInChapter = [];
	}
	var currentVideo;

	// console.log(players);
	// console.log(userData);


	///////////////////////
	 ///// video player /////
	 /////////////////////////////////////////////
	//on video click, call server and load it
	$(document).on('click',".js-video-open", function (e) {
		e.preventDefault();

		const id = $(this).attr('id'); //get video id to load

		const objIndex = userData.videos.findIndex((video => video.id == id)); //find video index in localstorage
		const userDataToSend = {
			videoid: id,
			userId: userData.userID,
			chapterId: userData.chapterID,
			videoNumber: objIndex+1,
		}
		if ($(".video-background").find(`#video-${id}`).length == 0) { //load video only if it doesnt exists
			loadVideo(userDataToSend); //call a function to load it
		} else {
			$(".video-background").addClass("active");
			var videoDialog = $('#video_dg_' + id);
			videoDialog.removeAttr('hidden').focus();
			popupStack.push($('#video_dg_' + id));
		}

	});


	//ajax call to fetch video. check misc.php line 112
	function loadVideo(userData) {
		var data = {
			action: "load_video",
			user_data: userData
		};

		jQuery.ajax({
			url: ajax.ajaxurl,
			data: data,
			type: "POST",
			beforeSend: function(xhr) {
				$('.video-container').remove();

			},
			success: function(data) {
				if (data.trim() !== ''){
					$(".video-background").addClass("active");
					$('.video-background').append(data);
					var videoDialog = $('#video_dg_' + userData.videoid);
					videoDialog.focus();
					popupStack.push(videoDialog);
					loadVideoControls(userData.videoid)
				}
			}
		});
	}

	//main function to track user interaction.
	function loadVideoControls(id) {
		console.log('loadVideoControls called');
		const player = new Plyr(`#video-${id}`);
		currentVideo = player;
		// console.log(player);
		// console.log(userData.videos);


		const videoInfo = userData.videos.filter(video => video.id === id)[0]
		// console.log(videoInfo);
		//Find index of specific object using findIndex method.

		var timeStarted = -1;
		var timePlayed = 0;
		var duration = player.duration;



		//set time if exists
		player.once('canplay', event => {
			player.currentTime = parseInt(videoInfo.videoTimeViewedInSeconds);
		 });

		player.on('play', event => {

			videoStartedPlaying();
			// console.log("Video started playing at:" + timeStarted);
		});

		player.on('playing', event => {
			videoStartedPlaying();
			// console.log("Video started playing at:" + timeStarted);
		});

		player.on('pause', event => {
			// console.log(player.currentTime);
		//	console.log(event);
			videoStoppedPlaying(event)

			//send update to DB
			updateVideoProgress(player.currentTime, id)

			//update local storage with new time
			updateLocalStorage(player.currentTime, id, videoInfo.videoCompleted, 1)
		  });

		player.on('ended', event => {
			videoStoppedPlaying(event)
		});


		// remember time user started the video
		function videoStartedPlaying() {
			timeStarted = new Date().getTime()/1000;
		}

		function videoStoppedPlaying(event) {
			// Start time less then zero means stop event was fired vidout start event
			if(timeStarted>0) {
				var playedFor = new Date().getTime()/1000 - timeStarted;
				timeStarted = -1;
				// add the new ammount of seconds played
				timePlayed+=playedFor;
			}
			// Count as complete only if end of video was reached
			if(timePlayed>=duration && event.type=="ended") {
				$(".repeat-or-next").toggleClass("active");
				// console.log('finish');
				//send updated to DB
				// updateVideoProgress(0, id, 1, 1)
				completeVideo(id, syncVideoProgress);

				//update local storage with new time
				updateLocalStorage(0, id, 1, 1)

				// //rerender new progress
				// syncVideoProgress(id);

				//if last video on chapter, mark chapter as complete and enable next one, and pop up summary
				if (isLastVideo(id)) {
					completeChapter();
					enableNextChapter();
				} else {
					//enable next video
					const nextVideo = enableNextVideo(id);
				}
			}
		}

	}

	///////////////////////
	///// Close video /////
	///////////////////////////////////////////////////////////////////////////////////////////////
	$(document).on("click", '.video-close', function(e) {
		e.preventDefault();

		//remove popup
		$(".video-background").removeClass("active");
		$('#video_dg').attr('hidden', true);
		// ADD STOP VIDEO
		currentVideo.pause();
	});

	///////////////////////
	///// Watch again /////
	///////////////////////////////////////////////////////////////////////////////////////////////
	$(document).on("click", '.again', function(e) {
		$(this).parent().removeClass("active");
		currentVideo.currentTime = 0;
		currentVideo.play();
	});


	///////////////////////
	 ///// NEXT video /////
	 ///////////////////////////////////////////////////////////////////////////////////////////////
	$(".video-controls").click(function (e) {
		e.preventDefault();
		$(".repeat-or-next").toggleClass("active");
	});


	///////////////////////
	 ///// Update progress /////
	 ///////////////////////////////////////////////////////////////////////////////////////////////
	function updateProgressToDB(userData) {
		var data = {
			action: "update_user_progress",
			user_data: userData
		};

		jQuery.ajax({
			url: ajax.ajaxurl,
			data: data,
			type: "POST",
			success: function(data) {
				// console.log('updated');
			}
		});
	}

	function completeVideo(videoId, fnCallback) {
		let dataToSend = {
			videoid: videoId,
			userId: userData.userID,
			chapterId: userData.chapterID,
		}
		var data = {
			action: "complete_video",
			user_data: dataToSend
		};
		jQuery.ajax({
			url: ajax.ajaxurl,
			data: data,
			type: "POST",
			success: function(data) {
				if(fnCallback) {
					fnCallback(videoId);
				}
				// console.log('updated');
			}
		});
	}


	///////////////////////
	 ///// Update local storage on pause/stop with the new time /////
	 ///////////////////////////////////////////////////////////////////////////////////////////////
	function updateLocalStorage(duration, id, completed, enabled) {
		const objIndex = userData.videos.findIndex((video => video.id == id)); //find video index in localstorage
		userData.videos[objIndex].videoTimeViewedInSeconds = duration // set new time in localstorage
		userData.videos[objIndex].videoCompleted = completed // set completed status in localstorage
		userData.videos[objIndex].videoEnabled = enabled // set new enabled status in localstorage

		localStorage.setItem("userProgress", JSON.stringify(userData))
	}

	/////////////////////////////////////////////////////////////////////
	 ///// Update DB on video pause/finish /////
	 ///////////////////////////////////////////////////////////////////////////////////////////////
	function updateVideoProgress(duration, id) {
		let dataToSend = {
			videoid: id,
			userId: userData.userID,
			chapterId: userData.chapterID,
			viewed: duration
		}

		//send new time to the server
		updateProgressToDB(dataToSend)
	}

	function getCurrentIndex(current) {
		return allVideoIdsInChapter.findIndex((id => id == current)); //find current video index
	}


	function isLastVideo(current) {
		const currentIndex = getCurrentIndex(current)

		if (allVideoIdsInChapter[currentIndex+1] === undefined) {
			return true;
		}
		return false;
	}

	function getNextVideoId(current){
		const currentIndex = getCurrentIndex(current)
		return allVideoIdsInChapter[currentIndex+1]
	}

	/////////////////////////////////////////////////////////////////////
	 ///// Enable next video when the current finish /////
	 ///////////////////////////////////////////////////////////////////////////////////////////////
	function enableNextVideo(current) {
		const currentIndex = getCurrentIndex(current); //find current video index

		// console.log(allVideoIdsInChapter);
		// console.log(currentIndex);

		const data = {
			action: "enable_video",
			user_data : {
				videoid: allVideoIdsInChapter[currentIndex+1], //enable next video in the list
				userId: userData.userID,
				chapterId: userData.chapterID,
			}
		};

		jQuery.ajax({
			url: ajax.ajaxurl,
			data: data,
			type: "POST",
			success: function(data) {
				// console.log('enabled');
			}
		});
		return allVideoIdsInChapter[currentIndex+1] //return next video ID
	}

	/////////////////////////////////////////////////////////////////////
	 ///// Start next video /////
	 ///////////////////////////////////////////////////////////////////////////////////////////////
	function startNextVideo(next) {
		const objIndex = userData.videos.findIndex((video => video.id == next)); //find video index in localstorage
		const userDataToSend = {
			videoid: next,
			userId: userData.userID,
			chapterId: userData.chapterID,
			videoNumber: objIndex+1,
		}
		if ($(".video-background").find(`#video-${next}`).length == 0) { //load video only if it doesnt exists
			loadVideo(userDataToSend);
		}
	}


	//next video on click listener
	$(document).on("click", '.next-video', function(e) {
		const id =  $(this).parent().parent().find("video").attr("id").match(/\d+/)[0];

		//get next video ID
		const next = getNextVideoId( id )

		//check if currentvideo is the last
		if (!isLastVideo(id)) {
			startNextVideo(next)
		} else {
			//if user clicked last video in chapter, but that chapter is not the last chapter in training
			const data = {
				action: "if_last_chapter",
				user_data : {
					userId: userData.userID,
					chapterId: userData.chapterID,
				}
			};

			jQuery.ajax({
				url: ajax.ajaxurl,
				data: data,
				type: "POST",
				success: function(data) {
					if (data =="yes") {
						//if user clicked on the last video in training, show summaty and training finished alert
						$(".popup-background.summary").addClass("active").removeAttr('hidden');
						$(".popup-background.training-alert-finished").addClass("active");
					} else {
						//if user clicked on the last video in chapter, show summary alert
						addClickEventForContinueToNextChapterButton();
						$(".popup-background.summary").addClass("active");
					}

				}
			});

		}

	});

	//complete the chapter
	function completeChapter() {
		console.log('completeChapter');
		const data = {
			action: "complete_chapter",
			user_data : {
				userId: userData.userID,
				chapterId: userData.chapterID,
			}
		};

		jQuery.ajax({
			url: ajax.ajaxurl,
			data: data,
			type: "POST",
			success: function(data) {
				console.log('completed chapter');
				//sync the progress on the frontend
				syncChapterProgress();
				addClickEventForContinueToNextChapterButton();
			}
		});
	}

	//enable next chapter
	function enableNextChapter() {
		console.log('enableNextChapter');
		const data = {
			action: "enable_chapter",
			user_data : {
				userId: userData.userID,
				chapterId: userData.chapterID,
			}
		};

		jQuery.ajax({
			url: ajax.ajaxurl,
			data: data,
			type: "POST",
			success: function(data) {
				console.log(data);
				//no next chapter, training ended
				if (data == "completed") {
					$(".popup-background.summary").addClass("active");
					$(".popup-background.training-alert-finished").addClass("active");
					completeUserTraining(userData.userId);
					//change nav to enable cert alert
					$('a.js-popup-trigger[href="#certificate_alert_disabled_dg"]').attr('href', '#cert_dg').removeClass('certificate-disabled').addClass('certificate');
				} else {
					//trigger summary popup
					$(".popup-background.summary").addClass("active");
					var chapter = $(".chapter-" + userData.chapterID);
					var nextChapterlink = chapter.closest('a').next('a');
					nextChapterlink.attr('href', nextChapterlink.data('chapterhref')).removeClass('js-popup-trigger').find('.chapter-disabled').removeClass('chapter-disabled');
					console.log('next chapter enabled');
				}
			}
		});
	}

	//send update to DB that user finished with the training
	function completeUserTraining(){
		const data = {
			action: "complete_training",
			userId: userData.userID,
		};

		jQuery.ajax({
			url: ajax.ajaxurl,
			data: data,
			type: "POST",
			success: function(data) {
				console.log("Training completed");
			}
		});
	}

	function syncVideoProgress(videoId) {

		//replace image inside video header
		var checkedImage = '<img src="/wp-content/themes/patientnamnden/build/assets/images/checked-light.svg" class="w-3 h-3">';
		var videoParent = $("#"+videoId).parent();
		var videoParentHeader = videoParent.find(".video-header");
		videoParentHeader.find("img").remove();
		videoParentHeader.append(checkedImage);

		//remove video disable class and click event from the next and current video
		var nextVideoId = getNextVideoId(videoId);
		videoParent.removeClass("video-disabled");
		var nextVideoParent = $("#"+nextVideoId).parent();
		nextVideoParent.removeClass("video-disabled");
		nextVideoParent.off("click");
		videoParent.off("click");

		//update progress bar
		const data = {
			action: "resync_progress_bar",
			userId: userData.userID,
			chapterId: userData.chapterID,
			videosCount: userData.videos.length
		};

		jQuery.ajax({
			url: ajax.ajaxurl,
			data: data,
			type: "POST",
			success: function(data) {
				$(".right-section-main").find(".outer-progress").remove();
				$(".right-section-main").prepend(data);

				setTimeout(function() {
					var progressEl = $(".inner-progress");
					var progress = progressEl.attr("data-progress") + "%";
					progressEl.css("width", progress);
				}, 500);

			}
		});
	}

	function syncChapterProgress() {
		var chapter = $(".chapter-" + userData.chapterID);
		var checkedImage = '<img src="/wp-content/themes/patientnamnden/build/assets/images/checked-dark.svg" class="w-3 h-3">'

		chapter.find("img").remove(); //remove unchecked image
		chapter.append(checkedImage); //add checkedImage

	}

	function addClickEventForContinueToNextChapterButton() {
		console.log('addClickEventForContinueToNextChapterButton')
		$(".popup-background.summary").on('click', ".bg-green", function (e) {
			window.location.href = getNextChapterPageUrl();
		});
	}

	function getNextChapterPageUrl() {
		var chapter = $(".chapter-" + userData.chapterID);

		return chapter.closest('a').next().attr("href");
	}
});







